import { QuotationMark } from "../icons/QuotationMark";
import MultiCarousel from "../MultiCarousel";

const quotes = [
  {
    text: "The reason we shifted from our homegrown competencies to the XQ Competencies is that they were robust, used accessible language, and had resources readily available.",
    name: "Chris Hanks",
    role: "Principal, Grand Rapids Public Schools",
  },
  {
    text: `The (XQ Competency) activities make otherwise "dead" concepts & skills come alive: students really encounter these ideas... instead of just having me yap at them.`,
    name: "Candice Anderson",
    role: "Grand Rapids High School Teacher",
  },
  {
    text: `At schools like mine aiming to make shifts towards not separating academic and SEL conversations ('teach the whole student at once') the competencies become very helpful.`,
    name: "Evan O'Connell",
    role: "New York City High School Teacher",
  },
];

export const Testimonials = () => {
  return (
    <div className="mx-auto max-w-screen-large">
      <h2 className="mb-8 px-4 text-center text-4xl leading-tight medium:mb-14 medium:px-6 medium:text-[64px]">
        What educators say about the XQ Competencies
      </h2>
      <div className="px-4 small:px-0 medium:hidden">
        <MultiCarousel
          options={{ loop: false }}
          containerClassName="auto-cols-[100%] small:auto-cols-auto small:w-[360px] small:mx-auto"
          slides={quotes.map((quote) => (
            <Quote
              key={`carousel-slide-quote:${quote.name}`}
              className="embla__slide small:w-[360px]"
              {...quote}
            />
          ))}
        />
      </div>
      <div className="hidden grid-cols-3 gap-4 px-6 medium:grid large:gap-6">
        {quotes.map((quote) => (
          <Quote key={`quote:${quote.name}`} {...quote} />
        ))}
      </div>
    </div>
  );
};

type QuoteProps = {
  text: string;
  name: string;
  role: string;
  className?: string;
};

const Quote = ({ text, name, role, className }: QuoteProps) => (
  <div
    className={`relative flex min-h-[456px] w-full flex-col justify-end rounded-3xl bg-BG-20 bg-[url('/assets/homepage/quote_background.png')] bg-cover bg-center bg-no-repeat text-center medium:min-h-[572px] [&:nth-of-type(2)]:bg-[top_200px_right_50px] [&:nth-of-type(3)]:bg-[bottom_100px_left_50px] ${className}`}
  >
    <QuotationMark className="absolute left-[30px] top-[30px]" />
    <p className="absolute top-1/2 w-full -translate-y-1/2 px-4 font-teodor text-[28px] leading-tight tracking-[-1px] medium:text-[32px] large:px-11">
      {text}
    </p>
    <p className="font-semibold leading-5">{name}</p>
    <p className="mb-8">{role}</p>
  </div>
);
